import { useMutation } from "@tanstack/react-query";
import { CreateTask } from "@coworker/apprestructured/src/task-management/types/Task";
import { createTask } from "@coworker/apprestructured/src/task-management/services/tasks.service";

export const useCreateTask = () => {
  return useMutation({
    mutationFn: (task: CreateTask) => createTask(task),
  });
};
